import React, { useEffect, useState } from 'react';
import { Swiper } from 'swiper/react';
import { Navigation } from 'swiper';
import * as styles from './commentsSlider.module.scss';

interface Props {
  children: React.ReactNode;
  setSwiper: any;
}

export const CommentsSlider: React.FC<Props> = ({ children, setSwiper }) => {
  return (
    <Swiper
      onSwiper={(swiper) => setSwiper(swiper)}
      navigation={{
        nextEl: '#prevElSwiper',
        prevEl: '#nextElSwiper',
      }}
      className={styles.swiper}
      loop={true}
    >
      {children}
    </Swiper>
  );
};
